/* @flow */
import cx from 'classnames';
import React from 'react';

import './styles/Buttons.scss';

class Buttons extends React.Component {
  static propTypes = {
    align: React.PropTypes.oneOf(['left', 'center', 'right']),
    axis: React.PropTypes.oneOf(['x', 'y']),
    full: React.PropTypes.bool,
  };

  static defaultProps = {
    align: 'center',
    axis: 'x',
  };

  render() {
    const children = React.Children.map(this.props.children, function(child, index) {
      return <div className="Buttons-item" key={index}>{child}</div>;
    });

    return (
      <div
        className={cx('Buttons', {
          'Buttons--x': this.props.axis === 'x',
          'Buttons--y': this.props.axis === 'y',
          'Buttons--left': this.props.align === 'left' && this.props.axis === 'x',
          'Buttons--right': this.props.align === 'right' && this.props.axis === 'x',
          'Buttons--full': this.props.full,
        })}>
        {children}
      </div>
    );
  }
}

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/Buttons.jsx